import { Gateway } from './gateway.model';

export interface Device {
  id: string;
  name?: string;
  isOnline?: boolean;
  tenantName?: string;
  tenantId?: string;
  gatewaySerial?: string;
  cabVersion?: string;
  machineSerial?: string;
  primaryConnectionString?: string;
  cloudToDeviceMessageCount?: number;
  firmwareVersion?: string;
}

export interface Machine extends Device {
  existingGateway?: Gateway;
  newGateway?: Gateway;
  gateway?: Gateway;
}

export interface MachineResponseErrorParams {
  [key: string]: string[];
}

export interface MIFRequest {
  mif: File;
  machineName: string;
  tenantId: string;
  softwareVersion: string;
  softwareLicense: string;
}

export class MachineResponseError extends Error {
  constructor(
    message: string,
    public params?: MachineResponseErrorParams
  ) {
    super(message);
  }
}

export enum MachineErrors {
  MACHINE_ALREADY_EXISTS = 'MACHINE_ALREADY_EXISTS',
  ENDORSEMENT_KEY_ALREADY_USED = 'ENDORSEMENT_KEY_ALREADY_USED',
  ENDORSEMENT_KEY_INVALID = 'ENDORSEMENT_KEY_INVALID',
  GATEWAY_ALREADY_EXISTS = 'GATEWAY_ALREADY_EXISTS',
  DEVICE_CREATION_ERROR = 'DEVICE_CREATION_ERROR',
}

export interface PurgeDeviceQueueResponse {
  id: string;
  messagesPurged: number;
}
